import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import {
  CompleteRegistrationModal,
  DeletePractitionerModal,
  EditPractitionerDrawer,
  NewPractitionerDrawer,
  ResetPasswordModal,
  SettingsPractitionersPageInfo,
} from './types';

export const pageInfoState = atom<SettingsPractitionersPageInfo>({
  page: 1,
  perPage: 25,
  totalPage: 1,
  totalCount: 0,
});

export const newDrawerState = atomWithReset<NewPractitionerDrawer>({
  isOpen: false,
  isPrivilege: false,
  organizationId: null,
});

export const editDrawerState = atomWithReset<EditPractitionerDrawer>({
  isOpen: false,
  isPrivilege: false,
  practitionerId: null,
});

export const completeRegistrationModalState = atomWithReset<CompleteRegistrationModal>({
  isOpen: false,
  practitionerId: null,
  practitionerCode: null,
});

export const deleteModalState = atomWithReset<DeletePractitionerModal>({
  isOpen: false,
  practitionerId: null,
  error: null,
});

export const resetPasswordModalState = atomWithReset<ResetPasswordModal>({
  isOpen: false,
  practitionerId: null,
});
